// SPDX-FileCopyrightText: 2022-2026 Lablup Inc. All rights reserved.
// SPDX-License-Identifier: LicenseRef-Proprietary
import { ApiResponseError, parseResponseError } from "./apiError";
import { fetchWithTimeout } from "./fetchWithTimeout";

/**
 * Fetch JSON with timeout and response validation.
 *
 * Combines `fetchWithTimeout` + `response.ok` check + `.json()` parsing.
 * Rejects with an `ApiResponseError` (a real `Error` carrying the parsed
 * `status` / `code` / `errorType`) on non-2xx responses.
 */
export async function fetchJson<T = unknown>(
  url: string,
  init?: RequestInit,
  timeoutMs?: number
): Promise<T> {
  const response = await fetchWithTimeout(url, init, timeoutMs);
  if (!response.ok) {
    throw new ApiResponseError(await parseResponseError(response, url));
  }
  return response.json() as Promise<T>;
}
